import React from 'react'
import { CgAdd } from 'react-icons/cg';
import './Todo.css'
import TodoLine from './TodoLine'

export default function Todo({title, lines, titleStyle, anAdd}) {  
  
  const compLines = lines.map(line => <TodoLine key={line.id} taskLine={line}/>);
  const titleClass = titleStyle;

  return (
    <div className='todo'>
      <div className='paper'>      
          <div className='todoContent'>
            <div>&nbsp;</div>
            <div style={{display:'flex', gap: 20}}>
              <CgAdd size='28px' color='#521' enableBackground='true' style={{marginLeft: -48,  borderRadius: 8}} onClick={anAdd}/>
              <div className={titleClass}>{title}</div>            
            </div>
            
            <div className='todoBody'>              
              {/* <MdCreate color='gray' size='24px' style={{marginLeft: -48}} onClick={anAdd}/> */}
              <div className='todoLinesContent'>
                {compLines}
              </div>
            </div>
          </div>
      </div>
    </div>
  )
}
